import React from "react"
import styled from "styled-components"
import { color } from "@smoothincorg/smooth-ui"

type DefaultCheckboxProps = Omit<JSX.IntrinsicElements["input"], "type">

type Props = DefaultCheckboxProps & {
  text: string
}

// eslint-disable-next-line react/display-name
const Component = React.forwardRef<HTMLLabelElement, Props>((props, ref) => {
  const className = [
    props.className,
    props.checked && `${props.className}--input_checked`,
    "checkbox",
  ].join(" ")

  return (
    <label className={className} htmlFor={props.id} ref={ref}>
      <input
        id={props.id}
        name={props.name}
        className={`${props.className}__checkbox`}
        type="checkbox"
        checked={props.checked}
        required={props.required}
        value={props.value}
        onChange={props.onChange}
        onBlur={props.onBlur}
      />
      <span className={`${props.className}__text`}>{props.text}</span>
    </label>
  )
})

const StyledComponent = styled(Component)`
  border-radius: 8px;
  border: 2px solid #e2e7ec;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &--input_checked {
    border: 2px solid ${color.main};
  }

  &__checkbox {
    display: block;
    background: #ffffff;
    box-sizing: border-box;
    outline: none;
    appearance: none;
    margin-right: 12px;
    margin-left: 4px;
    border: none;
    &:before {
      content: '';
      display: block;
      width: 20px;
      height: 20px;
      background: ${color.gray};
      border-radius: 4px;
    }

    &:checked {
      &:before {
        content: url('/images/checked.svg');
      }
    }
  }

  &__text {
    font-weight: bold;
    font-size: 1.4rem;
    text-align: left;
    color: #000000;
    @media screen and (max-width: 330px) {
      font-size: 1.1rem;
    }
    &--is_long {
      font-size: 1.1rem;
      @media screen and (max-width: 330px) {
        font-size: 1rem;
      }
    }
  }
`

export const Checkbox = StyledComponent
